var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#268BC8",
    d: "M30.001,4.768c10.076,0,18.274,8.197,18.274,18.273c0,3.871-1.282,7.625-3.81,11.164L30.001,54.473 L15.54,34.213c-2.531-3.547-3.814-7.305-3.814-11.172C11.726,12.965,19.924,4.768,30.001,4.768L30.001,4.768z M30.001,36 c7.144,0,12.956-5.814,12.956-12.959c0-7.141-5.812-12.951-12.956-12.951c-7.145,0-12.955,5.811-12.955,12.951 C17.046,30.186,22.856,36,30.001,36L30.001,36z M30.001,3.717c-10.675,0-19.327,8.654-19.327,19.324 c0,4.438,1.618,8.432,4.01,11.783c15.317,21.459,15.317,21.459,15.317,21.459s0,0,15.32-21.469 c2.392-3.346,4.006-7.336,4.006-11.773C49.327,12.371,40.674,3.717,30.001,3.717L30.001,3.717z M30.001,34.947 c-6.576,0-11.904-5.33-11.904-11.906c0-6.574,5.328-11.9,11.904-11.9c6.572,0,11.904,5.326,11.904,11.9 C41.905,29.617,36.573,34.947,30.001,34.947L30.001,34.947z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinIcon);
export default __webpack_public_path__ + "static/media/locationPinIcon.036c70961f3ac2f82d1876bea02c2109.svg";
export { ForwardRef as ReactComponent };